import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import { ITemplate } from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';

const queryFn = () => {
    const url = `api/bo/phaseperformance/getTemplateNames`;
    return network.post(url).then((response) => {
        return response.data;
    });
};

export const useQueryPhasePerformanceGetTemplates = () => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getTemplateNames'],
        queryFn: () => queryFn(),
    });
};

export interface QueryResponse {
    info: IToolTip;
    templates: ITemplate[];
}
